import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconDropdownRight } from '../../../../../assets/dashboard/dropdown-right-icon.svg';
import { CategoryImage } from './GenericComponents';

interface ICategoryInCardViewProps {
  categoryTitle: string;
  isCategoryChosen: boolean;
  categoryImageName: string;
  onCategoryDropDownClick?: () => void;
}

export const CategoryInCardView = ({
  categoryTitle,
  isCategoryChosen,
  categoryImageName,
  onCategoryDropDownClick,
}: ICategoryInCardViewProps) => {
  const { t } = useTranslation();
  const hasCategory = !!categoryTitle;
  return (
    <div className='flex items-center' role='button' tabIndex={0} onKeyDown={() => {}} onClick={onCategoryDropDownClick}>
      {hasCategory && <CategoryImage categoryImageName={categoryImageName} testId='CategoryInCardView__image' />}
      <div data-testid='CategoryInCardView__cat-title' className={`font-metricR text-sm leading-4 mx-[4px] truncate max-w-[140px] ${isCategoryChosen ? 'text-action05' : 'text-red02'}`}>{categoryTitle || t('CATEGORIZATION_CATEGORIES.CHOOSE_CATEGORY')}</div>
      <IconDropdownRight data-testid='CategoryInCardView__cat-icon-dropdown' className='rotate-90 relative top-[1px]' />
    </div>
  );
};
